export enum HttpStatusCode {
  Ok = 200,
  Found = 302,
}
